module.exports = __webpack_public_path__ + "img/horizontal_7_2_0.19dc62dd.png";